import { z } from "zod/v3";

export const generatedImagePath = /^\/api\/generated-images\/([a-f0-9]{64})\.png$/;
export const generateImageSchema = z.object({
  operationId: z.string().trim().min(1).max(100).describe("Unique ID for this generation. Reuse it when recovering the same request to avoid another charge."),
  prompt: z.string().trim().min(1).max(32000).describe("Describe the subject, composition, style, colors, lighting and intended use."),
  size: z.enum(["1024x1024", "1536x1024", "1024x1536"]).default("1024x1024"),
  quality: z.enum(["low", "medium", "high"]).default("medium"),
  background: z.enum(["auto", "opaque", "transparent"]).default("auto"),
}).strict();
export type GenerateImageInput = z.infer<typeof generateImageSchema>;
export type GeneratedImage = {
  id: string;
  operationId: string;
  src: string;
  width: number;
  height: number;
  model: string;
  createdAt: string;
};
export type ImageGenerationResult = GeneratedImage | {
  status: "queued" | "running";
  jobId: string;
  operationId: string;
  message: string;
};
export const IMAGE_GENERATION_DESCRIPTION = "Generate one picture, photo, illustration or transparent asset using OpenAI, charged to the connected account's Forma credits. Returns a saved image src and dimensions; add or update an image element with that src using the canvas edit tools. Hosted requests may return queued/running; call again with identical arguments to check status or list saved images. Only place the image after a src is returned. This does not change the canvas. Reuse operationId with identical arguments when retrying; list_generated_images recovers saved results. Use editable text and vector tools for UI, typography and simple geometry.";
